import { Component, OnInit } from "@angular/core";

@Component({
    selector: "app-eight-week-combined",
    templateUrl: "./eight-week-combined.component.html",
    styleUrls: ["./eight-week-combined.component.css"],
    standalone: false
})
export class EightWeekCombinedComponent {
  enrollNow() {
    // Handle enrollment logic here
    console.log("Enrollment clicked");
    // You can replace this with your actual enrollment logic
  }

  onCardHover(event: MouseEvent) {
    const card = event.currentTarget as HTMLElement;
    card.style.transform = "translateY(-10px) scale(1.02)";
  }

  onCardLeave(event: MouseEvent) {
    const card = event.currentTarget as HTMLElement;
    card.style.transform = "translateY(0px) scale(1)";
  }

  // Data for all weeks
  weeks = [
    {
      title: "1. The Pixel Perfect Creator: Frontend Development with Angular",
      content: `
      <p>For aspiring web developers ready to build stunning, interactive user experiences and launch modern web applications.</p>
     
      <p><strong>What You'll Master: </strong></p>
     <ul>
     <li> <strong>Week 1:</strong> Web Canvas Kickstart: HTML5, CSS (Flexbox/Grid), JavaScript fundamentals, and setting up your development environment.</li>
     <p></p>
     <li> <strong>Week 2:</strong> Angular Blueprint: Core Angular concepts: Components, Data Binding (Interpolation, Property, Event), and Directives (ngIf, ngFor).</li>
     <p></p>
     <li> <strong>Week 3:</strong> Angular Data Weave: Mastering Angular Services, Dependency Injection, passing data between components, and an introduction to Observables.</li>
     <p></p>
     <li> <strong>Week 4:</strong> Navigation Architect: Implementing Angular Router for multi-page navigation, dynamic routing, and an introduction to Route Guards.</li>
     <p></p>
     <li> <strong>Week 5:</strong> Form Forge: Building robust forms with both Template-driven and Reactive Forms, including built-in and custom validation.</li>
     <p></p>
     <li> <strong>Week 6:</strong> Project Enhancement Sprint: Elevating existing projects with UI/UX improvements, reusable components, and advanced form validations.</li>
     <p></p>
     <li> <strong>Week 7:</strong> Advanced Angular Alchemy: Diving into Pipes (built-in and custom), Lifecycle Hooks, Lazy Loading Modules, and a deeper dive into RxJS.</li>
     <p></p>
     <li> <strong>Week 8:</strong> Capstone Zenith & Deployment: Planning, coding, deploying, and presenting your full-stack Angular application online, preparing your GitHub repo, and updating your resume.</li>
     <p></p>
     <p></p>
     <p></p>
    </ul>

    <p><strong>Key Projects:</strong> Personal Portfolio Website, Todo List App, User Directory, Product Catalog, User Signup/Login Page, Employee Management System, and your Final Capstone Angular Application.</p>
     `,
    },

    {
      title: "2. The Data Whisperer: Data Science & Analytics",
      content: `
      <p>For future data analysts and scientists eager to extract powerful insights, build predictive models, and drive data-driven decisions. </p>
     
      <p><strong>What You'll Master: </strong></p>
     <ul>
     <li> <strong>Week 1:</strong> Python & Data Wrangling: Python basics, control flow, NumPy for numerical operations, Pandas for data manipulation, and essential data cleaning techniques. 
<br>
Project 1: Sales Data Exploratory Analysis & Report. </li>
     <p></p>
     <li> <strong>Week 2:</strong> ata Visualization & SQL: Creating impactful visualizations with Matplotlib and Seaborn, building interactive dashboards with Power BI, and mastering SQL for data querying and integration. 
<br>
Project 2: COVID-19 Dashboard (Power BI + SQL Integration). </li>
     <p></p>
     <li> <strong>Week 3:</strong> Statistics & Business Reporting: Understanding descriptive statistics, probability distributions, hypothesis testing, and advanced Excel for business reporting and analysis. 
<br>
Project 3: A/B Test Report (Excel + Statistical Analysis). </li>
     <p></p>
     <li> <strong>Week 4:</strong> Feature Engineering & Data Security: Techniques for handling missing data, feature scaling, encoding categorical variables, outlier detection, and crucial data security & ethics (GDPR, DPDP Act). 
<br>
Project 4: Customer Churn Analysis (Secure Data Handling). </li>
     <p></p>
     <li> <strong>Week 5:</strong> upervised Learning & Communication: Implementing Linear and Logistic Regression, Decision Trees, understanding model metrics (Accuracy, Precision, Recall), and mastering stakeholder communication. 
<br>
Project 5: Loan Approval Predictor (Model + Business Summary). </li>
     <p></p>
     <li> <strong>Week 6:</strong> nsupervised Learning & Big Data: Exploring clustering (k-Means), dimensionality reduction (PCA), association rules (Market Basket Analysis), and an introduction to Big Data concepts (Hadoop/Spark, NoSQL). 
<br>
Project 6: Market Segmentation (Clustering + Report). </li>
     <p></p>
     <li> <strong>Week 7:</strong> Deployment & Capstone Kickoff: Basics of Flask API for model deployment, cloud deployment strategies (AWS/GCP Free Tier), resume workshop, and initiating your Capstone Project. </li>
     <p></p>
     <li> <strong>Week 8:</strong> Capstone & Final Evaluation: Completing and presenting your Capstone Project (e.g., Fraud Detection, Recommendation System), culminating in mock interviews and a final panel defense.</li>
     <p></p>
     <p></p>
     <p></p>
    </ul>

    <p><strong>Integrated Soft Skills:</strong>  Daily soft skill tips on presentation, report writing, and stakeholder communication. Dedicated sessions on resume building and mock client presentations. </p>
     `,
    },

    {
      title: "3. The AI Alchemist: Generative AI Mastery (8-Week Program)",
      content: `
      <p>Delve into the cutting-edge world of Generative AI, building powerful models that create new content, from text and images to code. </p>
     
      <p><strong>What You'll Master: </strong></p>
     <ul>
     <li> <strong>Week 1 :</strong> AI & ML Fundamentals: Core concepts of AI, Machine Learning (Supervised, Unsupervised, Reinforcement), key algorithms (Linear/Logistic Regression, Decision Trees), and data preprocessing.  </li>
     <p></p>
     <li> <strong>Week 2:</strong> Deep Learning Foundations: Introduction to Neural Networks (Perceptrons, MLPs), Activation/Loss Functions, Backpropagation, CNNs for image tasks, and RNNs for sequential data. </li>
     <p></p>
     <li> <strong>Week 3:</strong> Generative AI Unveiled: Defining Generative AI, its applications (Text, Image, Audio Generation), basic Autoencoders, and crucial ethical considerations. </li>
     <p></p>
     <li> <strong>Week 4:</strong> VAEs & GANs Deep Dive: Understanding Variational Autoencoders (VAEs) for probabilistic generation and Generative Adversarial Networks (GANs) with their adversarial training. </li>
     <p></p>
     <li> <strong>Week 5:</strong> Transformers & Attention: Overcoming RNN limitations, mastering the Attention Mechanism (Scaled Dot-Product, Multi-Head), and exploring the Transformer Architecture (BERT, GPT concepts). </li>
     <p></p>
     <li> <strong>Week 6:</strong> Large Language Models (LLMs): Evolution of LLMs, pre-training/fine-tuning, Instruction Tuning, RLHF, and their diverse applications (text generation, summarization, chatbots). </li>
     <p></p>
     <li> <strong>Week 7:</strong> Diffusion Models & Advanced Techniques: Introduction to Diffusion Models (DDPMs, LDMs) for high-quality image generation, and a brief overview of other advanced generative techniques and multimodal AI. </li>
     <p></p>
     <li> <strong>Week 8:</strong> Deployment, Ethics & Future: Strategies for deploying Gen AI models (TensorFlow Serving, FastAPI, Cloud), model monitoring, advanced ethical considerations, responsible AI, and future trends. </li>
     <p></p>
     <p></p>
     <p></p>
    </ul>

    <p><strong>Key Projects:</strong> Simple Linear Regression, MLP for classification, Basic CNN for image classification, Basic Autoencoder, VAE for image generation, Basic GAN, and your Final Capstone Generative AI Project.  </p>
     `,
    },

    {
      title: "4. The Prompt Sorcerer: Prompt Engineering (2-Week Bootcamp) ",
      content: `
      <p>Master the art of communicating with AI to unlock its full potential, guiding Large Language Models to deliver precise and desired outputs. </p>
     
      <p><strong>What You'll Master: </strong></p>
     <ul>
     <li> <strong>Week 1: </strong> Prompt Engineering Fundamentals: Understanding LLMs, core principles of prompt design (clarity, conciseness, context, tone), and basic prompting techniques (Direct Instruction, Role-Playing, Format/Constraint Specification). </li>
     <p></p>
     <li> <strong>Week 2:</strong> dvanced Prompting & Applications: Exploring Few-Shot, One-Shot, and Zero-Shot prompting, Chain-of-Thought (CoT) prompting for complex tasks, controlling LLM behavior with parameters (Temperature, Top-P), and ethical considerations.</li>
     <p></p>
     <p></p>
     <p></p>
    </ul>

    <p><strong>Key Projects:</strong> Hands-on experimentation with public LLM APIs, refining prompts for specific output formats, and designing a multi-stage prompt engineering solution for a real-world problem. </p>
     `,
    },

    {
      title: "5. The Code Commander: Python Power-Up (2-Week Bootcamp)",
      content: `
      <p>Master the versatile Python language from basics to object-oriented programming and data handling – ideal for beginners or those seeking a strong foundation.</p>
     
      <p><strong>What You'll Master: </strong></p>
     <ul>
     <li> <strong>Week 1: </strong> Python Basics & Control Flow: Python history and setup, variables, data types, operators, basic input/output, conditional statements (if/elif/else), and loops (for/while), plus an introduction to functions and variable scope. </li>
     <p></p>
     <li> <strong>Week 2:</strong> Data Structures, OOP & File Handling: Working with Python's core data structures (Lists, Tuples, Sets, Dictionaries), basics of Object-Oriented Programming (Classes, Objects, Methods), file handling (reading/writing), error handling (try/except), and an introduction to modules and packages. </li>
     <p></p>
     <p></p>
     <p></p>
    </ul>

    <p><strong>Key Projects:</strong> Programs with user input and calculations, decision-making apps with if/else, data processing with loops, simple functions, and a Capstone Python application (e.g., a simple contact book, calculator, or text analysis tool) incorporating functions, data structures, and file handling. </p>
     `,
    },
  ];

  openIndex = 0; // open the first by default

  toggleAccordion(index: number) {
    this.openIndex = this.openIndex === index ? -1 : index;
  }

  openCta():void{
    window.open('https://zfrmz.in/th79mqpJrPEauzdclebY');
  }
}
